import { Position } from '@xyflow/react'
import { RolodexEntryPutJson, RolodexEntryType } from 'types'
import { v4 as uuidv4 } from 'uuid'

export const createProcessFlowID = () => {
  return uuidv4().slice(0, 16)
}

export const createProcessFlowEntry = (
  entryId: string,
  processFlowName: string,
  siteID: string
): RolodexEntryPutJson => {
  return {
    id: entryId,
    type: RolodexEntryType.PROCESS_FLOW_DIAGRAM,
    data: {
      metadata: {
        name: processFlowName,
      },
      diagram: {
        nodes: [],
        edges: [],
      },
    },
    tags: {
      site: siteID,
    },
  }
}

export const getRotatedHandleConfig = (
  logicalPosition: 'top' | 'right' | 'bottom' | 'left',
  rotation: number
) => {
  const positionMap = {
    top: {
      0: {
        position: Position.Top,
        style: { top: '0%', left: '50%' },
      },
      90: {
        position: Position.Right,
        style: { top: '0%', right: '50%' },
      },
      180: {
        position: Position.Bottom,
        style: { bottom: '100%', left: '50%' },
      },
      270: {
        position: Position.Left,
        style: { top: '0%', left: '50%' },
      },
    },
    right: {
      0: {
        position: Position.Right,
        style: { top: '50%', right: '0%' },
      },
      90: {
        position: Position.Bottom,
        style: { bottom: '50%', left: '100%' },
      },
      180: {
        position: Position.Left,
        style: { bottom: '50%', left: '100%' },
      },
      270: {
        position: Position.Top,
        style: { top: '50%', left: '100%' },
      },
    },
    bottom: {
      0: {
        position: Position.Bottom,
        style: { bottom: '0%', left: '50%' },
      },
      90: {
        position: Position.Left,
        style: { top: '100%', left: '50%' },
      },
      180: {
        position: Position.Top,
        style: { top: '100%', left: '50%' },
      },
      270: {
        position: Position.Right,
        style: { top: '100%', right: '50%' },
      },
    },
    left: {
      0: {
        position: Position.Left,
        style: { bottom: '50%', left: '0%' },
      },
      90: {
        position: Position.Top,
        style: { top: '50%', left: '0%' },
      },
      180: {
        position: Position.Right,
        style: { top: '50%', right: '100%' },
      },
      270: {
        position: Position.Bottom,
        style: { bottom: '50%', left: '0%' },
      },
    },
  }

  const config =
    positionMap[logicalPosition][rotation as keyof typeof positionMap.top]

  return {
    position: config.position,
    style: config.style,
  }
}
